import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
//Grab everything with import 'rxjs/Rx';
import { Observable, Observer, Subject, forkJoin, of } from "rxjs";
import { map, catchError, share, publishReplay } from "rxjs/operators";

import { environment } from "../../../../environments/environment";
declare var moment;

import {
    PaymentService, LineItem, ProductSubType,
    PaymentSummary,
    PaymentDetails,
    PaymentUIConfiguration,
    CustType,
    GPOrgCode,
    OrderSource,
    OrderTypeCode,
    OrderDetails,
    OrgCode,
    CardType
} from "@acepteam/payment";
import * as globalsvc from "@acepteam/globalspack";
import { MemberAppData } from "../../../shared/models";
import { GraduatingResidentOption } from "src/app/shared/models/my-account-data.models";
import { MemberAppDataService } from "../../services";
import { DataService } from "src/app/core/services";
import { NotificationStatus } from "src/app/shared/enums/data.enums";
import { MembershipRate } from "src/app/shared/enums/xrm.constants";

declare var $: any;

@Injectable({
    providedIn: "root"
})
export class SectionsService {
    constructor(
        private http: HttpClient,
        private globaldomops: globalsvc.GlobalDomOpsService,
        private globaldataops: globalsvc.GlobalDataOpsService,
        private ssosvc: globalsvc.AcepSSOService,
        private datasvc: DataService,
        private commonopssvc: globalsvc.CommonOperationsService,
        private paymentservice: PaymentService,
        private memberAppDataService: MemberAppDataService,
    ) {
    }

    public CalculateSectionOrder(memberAppData: MemberAppData, UOM_Override: string = '') {
        //let orderdetails: OrderDetails = new OrderDetails();
        var domain = window.location.href.indexOf('localhost') > -1 ? 'http://localhost/acep' : this.globaldataops.BasePath;
        var lineItems = this.CreateLineItemsForSectionApplicationOrder(memberAppData);

        //first check if we can just give comp sections and avoid shopping cart
        let isAcepMember = this.checkIfCurrentAcepMember_SectionApp(); // this.ssosvc.isacepmember;
        let isWithin3MonthsToMembExpiration = this.checkIfCurrentAcepMember_Within3MonthsToExpiry_SectionApp();
        if (isWithin3MonthsToMembExpiration) {
            lineItems.forEach(a => a.UOM = "Comp");
            // var payload = {
            //     contactid: this.ssosvc.contactid,
            //     sectionids: lineItems.map(a => a.AccountId).join(',')
            // }

            // this.http.post(
            //     this.datasvc.memberappapiendpoint + "UpdateSections",
            //     JSON.stringify(payload)
            // ).subscribe((d) => {
            //     if (d) {
            //         memberAppData.notifyInfo.status = NotificationStatus.SectionApplication_Comp;
            //         this.memberAppDataService.navigateToRoute('notifysectionapp');
            //     }
            // })



        }

        //check if curently an acep member with expiration date in the future.
        //if so, give the selected sections FREE/Comp and show an appropriate msg
        //MB 1/26/2025

        var orderdetails = {
            authorizationToken: this.ssosvc.toolkitauthencoded,
            backUrl: window.location.href,
            returnUrl: window.location.href,
            confirmUrl: `${domain}/utils/api/ninja/fakepost`,
            customerNumber: this.ssosvc.acepid,
            brand: '',
            orderType: isAcepMember ? 'Section' : 'SectionSubscription',
            gpOrganization: 'ACEP',
            organization: 'ACEP',
            priceList: 'MEMBERSHIP',
            lineItems: lineItems
        };

        $.redirect(domain + "/membership/handlers/payment.ashx",
            {
                paymentconfiguration: JSON.stringify(orderdetails)
            },
            "POST");







    }

    private CreateLineItemsForSectionApplicationOrder(memberAppData: MemberAppData): LineItem[] {

        let lineItems: LineItem[] = [];
        let isAcepMember = this.checkIfCurrentAcepMember_SectionApp(); // this.ssosvc.isacepmember;

        let sections = memberAppData.sectionDetails.sections.filter(c => c.selected && c.enabled);

        let currentRate = isAcepMember && MembershipRate[memberAppData.profile.membership.MemberRate];
        for (let index = 0; index < sections.length; index++) {
            let li = new LineItem();
            li.ProductSubType = isAcepMember ? ProductSubType.SECT : ProductSubType.SectionSubscription;
            li.AccountId = sections[index].id;
            li.ProductNumber = sections[index].productnumber;
            li.ProductName = sections[index].name;
            li.UOM = isAcepMember ? currentRate : 'EA';
            lineItems.push(li);
        }


        return lineItems;

    }


    public checkIfPastAcepMember_SectionApp() {
        let md = this.memberAppDataService.memberAppData;

        if (md) {
            let pastMember = (moment(md.profile.membership?.PaidThroughDate) < moment()) && !!md.profile.membership?.JoinDate;
            if (pastMember) {
                return true;
            }
        }
        return false;
    }

    public checkIfCurrentAcepMember_SectionApp() {
        let md = this.memberAppDataService.memberAppData;

        if (md) {
            let currentMember = (moment(md.profile.membership?.PaidThroughDate) > moment()) && !!md.profile.membership?.JoinDate;
            if (currentMember) {
                return true;
            }
        }
        return false;
    }

    public checkIfCurrentAcepMember_Within3MonthsToExpiry_SectionApp() {

        if (this.checkIfCurrentAcepMember_SectionApp()) {
            let md = this.memberAppDataService.memberAppData;
            let today = moment(); //moment('5/1/2016'); ////now
            let currentExpDate = moment(md.profile.membership.ExpirationDate);
            let numberofmonthsToExpirationDate = currentExpDate.diff(
                today,
                "months",
                true
            );

            if (numberofmonthsToExpirationDate > 0 && numberofmonthsToExpirationDate <= 3) {
                return true;
            }
        }
        return false;
    }
}